module.exports = __webpack_public_path__ + "img/67.f0c27f6f.jpg";